import Row from './components/Row';
import Col from './components/Col';

export default {
  Row,
  Col,
};
